import { InboxTable, SearchBar, Sectors } from './components';
import { childrenInboxPageBreadcrumbs } from './config';
import { useTicketFlowModals } from './context';
import { useNavigate } from 'react-router-dom';
import { NavigateLinks } from '@/components';
import { TicketFlowModals } from './modals';
import { ISector } from './models';
import { useMemo } from 'react';
import {
  useInbox,
  useInboxFilters,
  useRecoverTicket,
  useTotemSectorActions,
} from './hooks';

export const Inbox = () => {
  const { initialFilter, filter, setFilter } = useInboxFilters();

  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenInboxPageBreadcrumbs(navigate),
    [navigate]
  );

  useRecoverTicket();

  const { stats } = useInbox({
    filters: filter,
    paginated: { page: 1, pageSize: 1 },
  });

  const { setTicketData, openCallModal } = useTicketFlowModals();

  const { onCallNext, isLoadingCallNext } = useTotemSectorActions();

  const onCallNextCustomer = async () => {
    const data = await onCallNext(filter.sector.id);
    if (data) {
      setTicketData(data);
      openCallModal();
    }
  };

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks
        actualPage={filter.sector.name || 'Selecciona un sector'}
        breadcrumbs={breadcrumbs}
      />
      <SearchBar
        initialFilter={initialFilter}
        filter={filter}
        search={setFilter}
      />
      <TicketFlowModals />
      <div>
        <Sectors
          selectedSector={filter.sector}
          stats={stats}
          onCallNext={onCallNextCustomer}
          isLoadingCallNext={isLoadingCallNext}
          setSelectedSector={(sector: ISector) =>
            setFilter((prev) => ({ ...prev, sector: sector }))
          }
        />
        {filter.sector && <InboxTable filter={filter} />}
      </div>
    </section>
  );
};

export default Inbox;
